<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <div class="portlet-body" *ngIf="logEntryData">
      <div class="table-responsive">
        <table class="table table-striped table-bordered table-hover">
          <tbody>
            <tr>
              <th style="width: 30%">User</th>
              <th>Changes</th>
            </tr>
            <tr>
              <td>{{ logEntryData?.user }}</td>
              <td [innerHTML]="logEntrychanges">{{ logEntryData?.changes }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
